module.exports = __webpack_public_path__ + "img/arrow1.e0f05b1e.svg";